// ParentComponent.js

import React, { useEffect } from 'react';
import CookieHelper from "helpers/cookie";
import { useLocation } from 'react-router';
import store, {history} from '@/redux/store';
import { externLoginUser } from '@/reducers/Authorisation';
const ParentComponent = () => {
const location = useLocation();

  useEffect(() => {
    let locationParts = location.pathname.split('/');
    let locationKey = "";
    if(locationParts.constructor === Array && locationParts.length == 3) {
        locationKey = locationParts[2];
    }
    const params = new URLSearchParams(location.search);
    store.dispatch( externLoginUser({locationKey:locationKey, redirectTo: params.get('redirect')}) );
    return () => {

    };
  }, [location]);


  return (
    <div>
      <h1>CHECK</h1>
    </div>
  );
};

export default ParentComponent;
